module.exports = __webpack_public_path__ + "media/images/flags/KH-7ade54e5d15ba970203503749e8c3a15.svg";